// src/stores/form.ts
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { Component } from 'vue'

// Import components for dynamic form rendering
import Login from '@/components/Login.vue'
import Regiest from '@/components/Regiest.vue'
import Video from '@/components/Video.vue'
import Pay from '@/components/Pay.vue'
import Help from '@/components/Help.vue'
import Transfer from '@/components/Transfer.vue'
import Company from '@/components/Company.vue'
import EditUser from '@/components/EditUser.vue'
import trfRecode from '@/components/trfRecode.vue'
import CompanyTr from '@/components/CompanyTr.vue'
import MasterRead from '@/components/MustRead.vue'

// Define the form store with Pinia
export const useFormStore = defineStore('form', () => {
  const ShowForm = ref<'login' | 'regiest' | 'company' | 'video' | 'pay' | 'help' | 'transfer'|'trfRecode' | 'edituser' | 'CompanyTr'| 'MustRead' >('')

  const switchForm = (formType: typeof ShowForm.value) => {
    if ( formType === null )
      formType ='login'

    ShowForm.value = formType
    
  }

  const TargetForm = computed<Component>(() => {
    switch (ShowForm.value) {
      case 'login':
        return Login
      case 'regiest':
        return Regiest
      case 'video':
        return Video
      case 'pay':
        return Pay
      case 'help':
        return Help
      case 'transfer':
        return Transfer
      case 'company':
        return Company
      case 'edituser':
        return EditUser
      case 'trfRecode':
          return trfRecode    
      case 'CompanyTr':
          return CompanyTr
      case 'MustRead':
          return MasterRead
      default:
        return Login
    }
  })

 

  return {
    ShowForm,
    TargetForm,
    switchForm
  }
}, {
  persist: true,
})
